// ✏️  Edita los textos entre comillas
// ➕  Para agregar una opción, copia un bloque { } y pégalo
// ⚠️  No elimines llaves { }, corchetes [ ] ni comas ,

export const REPORTES = {
  mensaje: '¿Qué necesitas saber sobre reportes?',
  opciones: [
    {
      boton: '¿Cómo exportar a Excel?',
      respuesta: 'En las pantallas con tablas encontrarás un botón de exportación (ícono de Excel o botón "Exportar") en la barra de herramientas de la tabla.',
    },
    {
      boton: '¿Cómo imprimir un documento?',
      respuesta: 'En los formularios de documentos (facturas, guías, etc.) encontrarás un ícono de impresión 🖨️ en la barra de acciones. Esto genera el documento en PDF.',
    },
    {
      boton: 'El reporte aparece vacío',
      respuesta: 'Verifica que los filtros de fecha y demás criterios sean correctos y que existan registros en el período seleccionado.',
    },
    {
      boton: 'El PDF no se descarga',
      respuesta: 'Verifica que tu navegador no esté bloqueando las ventanas emergentes (pop-ups). Permite las ventanas emergentes para este sitio en la configuración del navegador.',
    },
  ],
}
